<script lang="ts">
	import { quadInOut } from 'svelte/easing';
	import { scale } from 'svelte/transition';
	import TakeProfit from './TakeProfit.svelte';
	import StopLoss from './StopLoss.svelte';
</script>

<div
	in:scale={{
		duration: 100,
		delay: 0,
		opacity: 0.9,
		start: 0.97,
		easing: quadInOut
	}}
>
	<TakeProfit />
	<StopLoss />
</div>

<style>
</style>
